import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";

/**
 * Functon type declare
 */
export type FuncAction = (
	dispatch: Dispatch,
	getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
	APP_CONNECT: {
		START: "APP_CONNECT_START",
		END: "APP_CONNECT_END",
	},

}

/**
 * All app state 
 */
export interface AndroidState {
	dataApp: undefined,
}

/**
 * App's action definition
 */
export interface IAndroidAction extends Action {
	payload: any;
}
